import cx from 'classnames'
import {Button} from 'components/system/Button'
import {capitalize, noop} from 'lodash'
import {MouseEvent, useCallback, useRef} from 'react'
import {SelectOption} from 'types/basic'

declare const Object: any

type Props = {
  options: SelectOption[]
  disabled?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
  name?: string
  value?: string
}

export const ButtonGroupInput = ({options, disabled, onChange = noop, className, name, value}: Props) => {
  const ref = useRef<any>(null)

  const setValue = useCallback((event: MouseEvent<HTMLButtonElement>, value: string) => {
    event.preventDefault()
    const e = new Event('change', {bubbles: true})

    if (ref.current) {
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set
      nativeInputValueSetter.call(ref.current, value)
      ref.current.dispatchEvent(e)
    }
  }, [])

  return (
    <div className="flex gap-4 flex-wrap">
      <input ref={ref} name={name} value={value} type="text" className="hidden" onChange={onChange} />

      {options.map((option) => {
        return (
          <Button
            key={option.value}
            onClick={(event) => setValue(event, option.value)}
            className={cx(
              'px-4 py-3 border rounded-lg border-solid',
              value === option.value ? 'border-theme' : 'border-gray-3'
            )}
          >
            {capitalize(option.label)}
          </Button>
        )
      })}
    </div>
  )
}
